import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const WebsiteBanner = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch banners from API on component mount
    const fetchBanners = async () => {
      try {
        const response = await axios.get("https://api.trubetx.com/banners"); // adjust base URL if needed
        setBanners(response.data);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
        setError("Failed to load banners.");
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

   const updateBanner = (id) => {
    navigate(`/banners/edit/${id}`);
  };

 

  return (
    <div className="ml-0 lg:ml-[230px] mt-4 bg-[#F5F5F4] pl-4 md:pl-0">
      <div className="flex items-center justify-between gap-1 rounded-t-lg px-5">
        <div>
          <h2 className="text-xl font-medium text-[#292524]">Website Banner</h2>
          <p className="mt-2">Web / Banners</p>
        </div>
        <div className="flex gap-1 mr-1">
          <button
            className="bg-[#228BE6] text-white px-4 py-2 !rounded-[5px] transition duration-200 ease-in-out hover:bg-[#153223] active:bg-[#25ed87] focus:outline-none"
            onClick={() => navigate("/banners/create")}
          >
            Add Banner
          </button>
        </div>
      </div>

       <section className="mt-4 grid gap-5 px-5">
        <div className="grid grid-cols-1 gap-4 rounded-lg py-4 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
          {banners?.map((item, index) => (
            <div key={item.id} className="overflow-clip rounded-lg bg-white shadow-sm">
              <div className="cursor-pointer">
                <div className="relative h-32">
                  <img
                    alt="Banner"
                    loading="lazy"
                    decoding="async"
                    src={"https://api.trubetx.com/uploads/"+ item.url}
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent",
                    }}
                  />
                </div>
              </div>
              <div className="bg-white rounded-b-lg px-2 py-3">
                <div className="flex items-center justify-between gap-4">
                 
                  <div className="relative text-center">
                    <p className="z-30 -mb-2 text-xs">POSITION</p>
                    <input
                      className="rounded-lg -mb-2 w-16 border-none bg-transparent text-center"
                      type="number"
                      value={item.order_no || item.order} // adapt if your DB uses order_no or order
                      readOnly
                    />
                  </div>
                  <div>
                    <div  onClick={() => updateBanner(item.id)} className="cursor-pointer">
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-base"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WebsiteBanner;
